import Reservation from "@components/Reservation";
import { useProfileReservationsQuery } from "@graphql/api";
import ConcentricLoader from "@hudson/ui/components/Loader/ConcentricLoader";
import Session from "@lib/session";
import useContent from "@lib/use_content";
import readRes from "@services/read_res";
import useWindowSize from "@utils/use_window_size";
import { useState } from "react";
import NoReservations from "./NoReservations";

interface ReservationListProps {
  dateRange?: be.ProfileReservationDateRange;
  onPageChange: (page: string) => void;
  profileId: number;
}

export default function ReservationList({
  dateRange = "future",
  onPageChange,
  profileId,
}: ReservationListProps) {
  const { data } = useContent([
    "beProfileResViewDetailsButton",
    "beProfileResViewDetailsOpenButton",
  ]);
  const [loading, setLoading] = useState<number>();
  const {
    data: resData,
    loading: resLoading,
    error,
  } = useProfileReservationsQuery({
    variables: { dateRange, id: profileId },
  });

  const [size] = useWindowSize();

  if (error) {
    console.error(error);
    return null;
  }

  async function viewDetails(resId: number) {
    if (!resId) return;

    setLoading(resId);

    let booking = await readRes({ resId });
    setLoading(undefined);
    if (booking) {
      booking.flags = { ...booking.flags, keepUserLoggedIn: true };
      Session.setVerifiedBooking(booking);
      onPageChange("res_summary");
    }
  }

  return resLoading ? (
    <ConcentricLoader className="max-w-2xl px-4 mx-auto opacity-60 sm:py-10 sm:px-6 lg:px-8" />
  ) : (
    <div className="flex flex-col mt-8 gap-y-8" key={dateRange}>
      {!resLoading && resData?.profileReservations?.length == 0 ? (
        <NoReservations />
      ) : (
        resData?.profileReservations?.map((res) => (
          <div
            className="relative px-2 py-4 border-b-4 shadow-sm bg-gray-50 xs:px-4 rounded-2xl"
            key={res.id}
          >
            <Reservation
              key={res.id}
              res={res}
              vertical={size < 640}
              actions={[
                {
                  label: res.service?.selectedTime?.pickupTime
                    ? data?.content.beProfileResViewDetailsButton || ""
                    : data?.content.beProfileResViewDetailsOpenButton || "",
                  disabled: !!(loading && res.resIdInternal != loading),
                  loading: res.resIdInternal == loading,
                  onClick: () => viewDetails(parseInt(res.id)),
                },
              ]}
              compact
              hideLocationString
            />
          </div>
        ))
      )}
    </div>
  );
}
